module.exports = {"deleteLink":"Mich als Guardian löschen","meta":"Ich bin Guardian"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/proteges.json
// module id = NEl7
// module chunks = 1